import { TEST_CATALOG as _TEST_CATALOG, CLINICAL_SCREENING_CATALOG as _CLINICAL_CATALOG } from "./testCatalog";
import { buildCardImageUrl } from "../utils/testCardImage";

export { TEST_CATALOG } from "./testCatalog";

export const CHART_KIND = {
  PAIRED_BOX: "pairedBox",
  INDEPENDENT_BARS: "independentBars",
  SCATTER: "scatter",
  ANOVA_BARS: "anovaBars",
  CHI_SQUARE: "chiSquare",
  SURVIVAL: "survival",
  ROC: "roc",
  FOREST: "forest",
  HEATMAP: "heatmap",
  TIME_SERIES: "timeSeries",
  VIOLIN: "violin",
};

export const CATEGORY_LABELS = {
  group: "Grup Karşılaştırma",
  relation: "İlişki ve Korelasyon",
  categorical: "Kategorik Testler",
  frequency: "Sıklık ve Oran",
  regression: "Regresyon ve Tahmin",
  advanced: "İleri Analiz",
};

export const CATEGORY_SHORT = {
  group: "Karşılaştır",
  relation: "İlişki",
  categorical: "Kategorik",
  frequency: "Sıklık",
  regression: "Regresyon",
  advanced: "İleri",
};

export const CATEGORY_ORDER = [
  "group",
  "relation",
  "categorical",
  "frequency",
  "regression",
  "advanced",
];

export const GALLERY_SLIDES = [
  {
    id: "independent",
    title: "Bagimsiz Gruplar",
    subtitle: "p = 0.032",
    description:
      "Iki bagimsiz grubun ortalama KOOS skorlarini karsilastirir.",
    chartKind: CHART_KIND.INDEPENDENT_BARS,
  },
  {
    id: "scatter",
    title: "Korelasyon",
    subtitle: "r = -0.72, p < 0.001",
    description: "Yas ile fonksiyonel skor arasindaki dogrusal iliskiyi gosterir.",
    chartKind: CHART_KIND.SCATTER,
  },
  {
    id: "timeseries",
    title: "Zaman Serisi",
    subtitle: "Ortalama ± SD",
    description: "Zaman icinde ortalama ve standart sapma bandini sunar.",
    chartKind: CHART_KIND.TIME_SERIES,
  },
  {
    id: "survival",
    title: "Sagkalim (K-M)",
    subtitle: "Log-rank p = 0.003",
    description: "Kaplan-Meier egirileri ile grup karsilastirmasi yapar.",
    chartKind: CHART_KIND.SURVIVAL,
  },
  {
    id: "roc",
    title: "ROC Egrisi",
    subtitle: "AUC = 0.847",
    description: "ROC egrisi ile tani gucunu degerlendirir.",
    chartKind: CHART_KIND.ROC,
  },
  {
    id: "forest",
    title: "Forest Plot",
    subtitle: "OR + %95 CI",
    description: "Cok degiskenli hazard oranlarini ozetler.",
    chartKind: CHART_KIND.FOREST,
  },
  {
    id: "heatmap",
    title: "Korelasyon Matrisi",
    subtitle: "Isi Haritasi",
    description: "Degiskenler arasi korelasyon matrisini gorsellestirir.",
    chartKind: CHART_KIND.HEATMAP,
  },
  {
    id: "pairedbox",
    title: "Paired Kutu",
    subtitle: "*** p < 0.001",
    description: "Pre-op ve 6. ay skor dagilimini karsilastirir.",
    chartKind: CHART_KIND.PAIRED_BOX,
  },
];

export function getCatalogTest(testId) {
  // Klinik modüller (tarama / fenotipleme) ayrı katalogdadır; yoksa ad/etiket
  // aramaları "Paired t-test" varsayılanına düşüyordu.
  return _TEST_CATALOG.find((test) => test.id === testId)
    || (Array.isArray(_CLINICAL_CATALOG) ? _CLINICAL_CATALOG.find((test) => test.id === testId) : null)
    || null;
}
export const RECOMMENDATIONS = {
  paired_t_test: { checks: ["Normal dagilim (Shapiro-Wilk p=0.38)", "2 bagimli grup tespit edildi"], recommended: "Paired t-test", alternative: "Wilcoxon (non-parametrik)" },
  independent_t: { checks: ["Normal dagilim (gruplarda p>0.05)", "2 bagimsiz grup tespit edildi"], recommended: "Bagimsiz t-test", alternative: "Mann-Whitney U" },
  pearson: { checks: ["Iki surekli degisken secildi", "Dogrusal iliski varsayimi uygun"], recommended: "Pearson korelasyon", alternative: "Spearman (sirali veri)" },
  regression: {
    checks: ["Surekli bagimli degisken (Y) secildi", "Bagimsiz ongörücü(ler) benzersiz ve Y'den farkli"],
    recommended: "Doğrusal regresyon (OLS)",
    alternative: "Pearson korelasyon (tek iliski ozeti)",
  },
  anova: { checks: ["3 grup tespit edildi", "Varyans homojenligi (Levene p=0.21)"], recommended: "Tek yonlu ANOVA", alternative: "Kruskal-Wallis" },
  chi_square: { checks: ["2x2 kategorik tablo olusturuldu", "Beklenen hucre sayisi >=5"], recommended: "Ki-kare testi", alternative: "Fisher Exact" },
  forest: { checks: ["Ikili sonuc tanimlandi", "En az bir prediktor secildi"], recommended: "Lojistik Regresyon (Forest Plot)", alternative: "ROC / Ki-kare" },
  kaplan_meier: { checks: ["Olay (event) degiskeni tanimlandi", "2 grup karsilastirmasi"], recommended: "Kaplan-Meier + Log-Rank", alternative: "Cox Regresyon" },
  roc: { checks: ["Binary outcome tanimlandi", "Continuous predictor secildi"], recommended: "ROC Egrisi (AUC)", alternative: "Lojistik Regresyon" },
  descriptive_stats: {
    checks: ["Surekli degiskenler secildi", "Grup veya tek kol veri seti hazir"],
    recommended: "Betimsel istatistik tablosu",
    alternative: "Shapiro-Wilk + Levene",
  },
  reliability_alpha: {
    checks: ["Likert maddeleri tanimlandi", "Tek faktor varsayimi kontrol edildi"],
    recommended: "Cronbach Alpha",
    alternative: "Split-half guvenilirlik",
  },
  inter_observer: {
    checks: ["Iki gozlemci kodlamasi mevcut", "2x2 veya nxn uyum tablosu olusturuldu"],
    recommended: "Cohen's Kappa",
    alternative: "Weighted Kappa",
  },
};

export const TEST_RESULTS = {
  paired_t_test: {
    id: "paired_t_test",
    displayName: "Paired t-test",
    chartKind: CHART_KIND.PAIRED_BOX,
    isSignificant: true,
    significanceBannerText: "Istatistiksel olarak ANLAMLI fark bulundu (p < 0.001)",
    methodSummary: "Paired t-test uygulandi. 48 hastanin ameliyat oncesi ve 6. ay KOOS skorlarina bakildi.",
    highlights: [{ label: "p degeri", value: "< 0.001", badge: "Anlamli", badgePositive: true }, { label: "Ortalama Fark", value: "29.5 puan" }, { label: "Etki Buyuklugu", value: "1.21", badge: "Cok buyuk", badgePositive: true }],
    descriptiveHeader: ["Zaman", "n", "Ort.", "SS"],
    descriptiveRows: [["Pre-op", "48", "42.3", "12.1"], ["6. Ay", "48", "71.8", "9.4"]],
    testStatHeader: ["Istatistik", "Deger"],
    testStatRows: [["t", "-8.41"], ["df", "47"], ["p", "< 0.001"], ["Cohen's d", "1.21"]],
    pValueRowIndex: 2,
    clinicalInterpretation: "6. ayda diz fonksiyonunda klinik olarak da anlamli iyilesme vardir.",
  },
  independent_t: {
    id: "independent_t",
    displayName: "Bagimsiz t-test",
    chartKind: CHART_KIND.INDEPENDENT_BARS,
    isSignificant: true,
    significanceBannerText: "Istatistiksel olarak ANLAMLI fark bulundu (p = 0.032)",
    methodSummary: "Teknik A ve Teknik B gruplarinin KOOS skorlarina bagimsiz t-test uygulandi.",
    highlights: [{ label: "p degeri", value: "0.032", badge: "Anlamli", badgePositive: true }, { label: "Ortalama Fark", value: "6.3 puan" }, { label: "Cohen's d", value: "0.58" }],
    descriptiveHeader: ["Grup", "n", "Ort.", "SS"],
    descriptiveRows: [["Teknik A", "26", "68.2", "10.4"], ["Teknik B", "22", "74.5", "9.1"]],
    testStatHeader: ["Istatistik", "Deger"],
    testStatRows: [["t", "2.21"], ["df", "46"], ["p", "0.032"], ["Cohen's d", "0.58"]],
    pValueRowIndex: 2,
    clinicalInterpretation: "Teknik B, orta etki buyuklugunde daha iyi fonksiyonel sonuclar sunmaktadir.",
  },
  pearson: {
    id: "pearson",
    displayName: "Pearson Korelasyon",
    chartKind: CHART_KIND.SCATTER,
    isSignificant: true,
    significanceBannerText: "Istatistiksel olarak ANLAMLI iliski (p < 0.001)",
    methodSummary: "Yas ile KOOS arasinda Pearson korelasyon analizi yapildi.",
    highlights: [{ label: "r", value: "-0.72" }, { label: "p degeri", value: "< 0.001", badge: "Anlamli", badgePositive: true }, { label: "R²", value: "0.52" }],
    descriptiveHeader: ["Degisken", "Ort.", "SS"],
    descriptiveRows: [["Yas", "45.2", "12.8"], ["KOOS", "64.1", "14.2"]],
    testStatHeader: ["Istatistik", "Deger"],
    testStatRows: [["r", "-0.72"], ["p", "< 0.001"], ["n", "48"]],
    pValueRowIndex: 1,
    clinicalInterpretation: "Ileri yas hastalarda fonksiyonel skorlar daha dusuk olma egilimindedir.",
  },
  regression: {
    id: "regression",
    displayName: "Doğrusal Regresyon (OLS)",
    chartKind: CHART_KIND.SCATTER,
    isSignificant: true,
    significanceBannerText: "Istatistiksel olarak ANLAMLI model (p < 0.001)",
    methodSummary:
      "OLS doğrusal regresyon uygulandı. Bağımsız öngörücü(ler) ile sürekli klinik sonuç modellendi.",
    highlights: [
      { label: "Regression Coefficient", value: "-0.84" },
      { label: "p degeri", value: "< 0.001", badge: "Anlamli", badgePositive: true },
      { label: "R²", value: "0.52" },
      { label: "Adj. R²", value: "0.51" },
    ],
    descriptiveHeader: ["Degisken", "Ort.", "SS"],
    descriptiveRows: [["BMI", "28.4", "4.1"], ["KOOS", "64.1", "14.2"]],
    testStatHeader: ["Istatistik", "Deger"],
    testStatRows: [
      ["Regression Coefficient", "-0.84"],
      ["R²", "0.52"],
      ["Adj. R²", "0.51"],
      ["p", "< 0.001"],
    ],
    pValueRowIndex: 3,
    clinicalInterpretation:
      "Model, öngörücüdeki birim değişimin sonuç skorundaki beklenen değişimi (beta) ve açıklanan varyansı (R²) raporlar.",
  },
  anova: {
    id: "anova",
    displayName: "Tek Yonlu ANOVA",
    chartKind: CHART_KIND.ANOVA_BARS,
    isSignificant: true,
    significanceBannerText: "Gruplar arasi ANLAMLI fark (p < 0.001)",
    methodSummary: "Uc tedavi grubu ANOVA ile karsilastirildi, post-hoc Tukey uygulandi.",
    highlights: [{ label: "F", value: "12.4" }, { label: "p degeri", value: "< 0.001", badge: "Anlamli", badgePositive: true }, { label: "eta²", value: "0.35" }],
    descriptiveHeader: ["Grup", "n", "Ort.", "SS"],
    descriptiveRows: [["Konservatif", "18", "58.4", "11.2"], ["Artroskopi", "16", "71.2", "9.8"], ["Acik cerrahi", "14", "76.8", "8.5"]],
    testStatHeader: ["Istatistik", "Deger"],
    testStatRows: [["F(2,45)", "12.4"], ["p", "< 0.001"], ["eta²", "0.35"]],
    pValueRowIndex: 1,
    clinicalInterpretation: "Cerrahi gruplar konservatif tedaviye gore daha yuksek skor vermistir.",
  },
  chi_square: {
    id: "chi_square",
    displayName: "Ki-kare",
    chartKind: CHART_KIND.CHI_SQUARE,
    isSignificant: true,
    significanceBannerText: "Degiskenler arasinda ANLAMLI iliski (p = 0.003)",
    methodSummary: "Tedavi tipi ile iyilesme durumunun iliskisi ki-kare testi ile analiz edildi.",
    highlights: [{ label: "chi²", value: "8.94" }, { label: "p degeri", value: "0.003", badge: "Anlamli", badgePositive: true }, { label: "Cramer's V", value: "0.31" }],
    descriptiveHeader: ["", "Iyilesmedi", "Iyilesti"],
    descriptiveRows: [["Konservatif", "18", "12"], ["Cerrahi", "8", "22"]],
    testStatHeader: ["Istatistik", "Deger"],
    testStatRows: [["chi²(1)", "8.94"], ["p", "0.003"], ["n", "60"]],
    pValueRowIndex: 1,
    clinicalInterpretation: "Cerrahi grupta iyilesme orani daha yuksektir.",
  },
  heatmap: {
    id: "heatmap",
    displayName: "Cohen Kappa",
    chartKind: CHART_KIND.HEATMAP,
    isSignificant: false,
    significanceBannerText: "Gozlemciler arasi uyum kappa ile ozetlendi",
    methodSummary: "Iki kodlayicinin kategorik siniflandirmalari arasindaki uyum Cohen kappa ile degerlendirildi.",
    highlights: [],
    descriptiveHeader: ["Kategori", "n", "Ort. (%)", "SS"],
    descriptiveRows: [],
    testStatHeader: ["Istatistik", "Deger"],
    testStatRows: [],
    pValueRowIndex: -1,
    clinicalInterpretation: "",
  },
  forest: {
    id: "forest",
    displayName: "Forest Plot",
    chartKind: CHART_KIND.FOREST,
    isSignificant: true,
    significanceBannerText: "Odds oranlari forest plot ile ozetlendi",
    methodSummary: "Lojistik regresyon katsayilari odds orani ve guven araligi olarak gorsellestirildi.",
    highlights: [],
    descriptiveHeader: ["Degisken", "n", "Ort.", "SS"],
    descriptiveRows: [],
    testStatHeader: ["Istatistik", "Deger"],
    testStatRows: [],
    pValueRowIndex: -1,
    clinicalInterpretation: "",
  },
  kaplan_meier: {
    id: "kaplan_meier",
    displayName: "Kaplan-Meier",
    chartKind: CHART_KIND.SURVIVAL,
    isSignificant: true,
    significanceBannerText: "Gruplar arasi ANLAMLI sagkalim farki (Log-rank p = 0.003)",
    methodSummary: "Iki grubun 36 aylik sagkalim verisi Kaplan-Meier ile karsilastirildi.",
    highlights: [{ label: "Medyan Sagkalim", value: "28 ay" }, { label: "Log-rank p", value: "0.003", badge: "Anlamli", badgePositive: true }, { label: "HR", value: "0.62" }],
    descriptiveHeader: ["Grup", "n", "24 Ay K-M"],
    descriptiveRows: [["Teknik A", "24", "0.88"], ["Teknik B", "22", "0.78"]],
    testStatHeader: ["Istatistik", "Deger"],
    testStatRows: [["Log-rank", "8.76"], ["p", "0.003"], ["HR", "0.62"]],
    pValueRowIndex: 1,
    clinicalInterpretation: "Teknik A'nin uzun donem implant sagkalimini artirdigi goruldu.",
  },
  roc: {
    id: "roc",
    displayName: "ROC",
    chartKind: CHART_KIND.ROC,
    isSignificant: true,
    significanceBannerText: "Tani gucu YUKSEK (AUC = 0.847)",
    methodSummary: "ROC analizi ile pre-op KOOS skorunun basari ongorusu olculdu.",
    highlights: [{ label: "AUC", value: "0.847", badge: "Iyi", badgePositive: true }, { label: "Optimal Esik", value: "48" }, { label: "Sensitivite", value: "0.82" }],
    descriptiveHeader: ["Esik", "Sensitivite", "Spesifisite"],
    descriptiveRows: [["42", "0.91", "0.71"], ["48", "0.82", "0.79"], ["55", "0.68", "0.88"]],
    testStatHeader: ["Istatistik", "Deger"],
    testStatRows: [["AUC", "0.847"], ["%95 CI", "[0.74-0.95]"], ["Optimal esik", "48"]],
    pValueRowIndex: -1,
    clinicalInterpretation: "Pre-op KOOS skoru, post-op basari tahmininde kullanilabilir bir gostergedir.",
  },
};

export function getResultForTest(testId) {
  const item = getCatalogTest(testId);
  if (!item) return TEST_RESULTS.paired_t_test;
  return TEST_RESULTS[item.resultId] || TEST_RESULTS.paired_t_test;
}

export function getRecommendationForTest(testId) {
  const item = getCatalogTest(testId);
  if (!item) return RECOMMENDATIONS.paired_t_test;
  return RECOMMENDATIONS[item.resultId] || RECOMMENDATIONS.paired_t_test;
}

/** Kart görseli — yalnızca WebP (`kart-gorselleri/{id}.webp`) */
export const STATS_TEST_THUMB = (testId) => buildCardImageUrl(testId);

export const STAT_PROFILE_SECTIONS = [
  {
    resultId: "paired_t_test",
    heading: "Eslestirilmis Karsilastirmalar",
    subtitle: "Ayni hastada iki zaman noktasi ve paired non-parametrik alternatifler",
    extraTestIds: [],
  },
  {
    resultId: "independent_t",
    heading: "Bagimsiz Grup Karsilastirmalari",
    subtitle: "Iki bagimsiz kol, betimsel ozet ve varyans analizi",
    extraTestIds: ["descriptive_stats"],
  },
  {
    resultId: "anova",
    heading: "Coklu Grup & Tekrarli Olcumler",
    subtitle: "3+ grup, longitudinal zaman noktalari ve non-parametrik karsiliklari",
    extraTestIds: [],
  },
  {
    resultId: "pearson",
    heading: "Iliskiler & Ongoru Regresyonlari",
    subtitle: "Korelasyon, regresyon, guvenilirlik ve sayim modelleri",
    extraTestIds: ["reliability_alpha"],
  },
  {
    resultId: "regression",
    heading: "Regresyon & Tahmin Modelleri",
    subtitle: "OLS dogrusal ve coklu dogrusal regresyon kanvasi",
    extraTestIds: [],
  },
  {
    resultId: "chi_square",
    heading: "Oranlar & Kategorik Matrisler",
    subtitle: "Capraz tablo, gozlemci uyumu ve lojistik sonuclar",
    extraTestIds: ["inter_observer"],
  },
  {
    resultId: "kaplan_meier",
    heading: "Sagkalim & Implant Omru",
    subtitle: "Kaplan-Meier, log-rank, Cox ve AFT sagkalim modelleri",
    extraTestIds: [],
  },
  {
    resultId: "roc",
    heading: "Teshis Gucu & Sinir Noktalari",
    subtitle: "ROC/AUC, optimal esik ve klinik ayrim performansi",
    extraTestIds: [],
  },
];

export function getTestsForSection(section) {
  const primary = _TEST_CATALOG.filter((test) => test.resultId === section.resultId);
  const extras = (section.extraTestIds || [])
    .map((id) => getCatalogTest(id))
    .filter(Boolean);
  const seen = new Set();
  return [...primary, ...extras].filter((test) => {
    if (seen.has(test.id)) return false;
    seen.add(test.id);
    return true;
  });
}

/** @deprecated Use getTestsForSection */
export function getTestsForProfile(resultId) {
  const section = STAT_PROFILE_SECTIONS.find((s) => s.resultId === resultId);
  return section ? getTestsForSection(section) : _TEST_CATALOG.filter((t) => t.resultId === resultId);
}

export const PROFILE_ACCENT = {
  paired_t_test: { from: "#3e4396", to: "#1F2A40", glow: "rgba(76,206,172,0.25)" },
  independent_t: { from: "#2a4a7c", to: "#101624", glow: "rgba(134,141,251,0.28)" },
  anova: { from: "#1a5c6e", to: "#101624", glow: "rgba(76,206,172,0.22)" },
  pearson: { from: "#3d2e6e", to: "#101624", glow: "rgba(134,141,251,0.3)" },
  regression: { from: "#2e4a6e", to: "#101624", glow: "rgba(76,206,172,0.28)" },
  chi_square: { from: "#4a3560", to: "#101624", glow: "rgba(104,112,250,0.25)" },
  kaplan_meier: { from: "#1e4d3a", to: "#101624", glow: "rgba(76,206,172,0.3)" },
  roc: { from: "#4a3060", to: "#101624", glow: "rgba(134,141,251,0.28)" },
};

export function getTestCardStats(testId) {
  const item = getCatalogTest(testId);
  if (!item) {
    return { sample: "N ≥ 20", dataType: "Sürekli (Continuous)", assumption: "Klinik Varsayım" };
  }
  return {
    sample: item.nRequirement,
    dataType: item.dataType,
    assumption: item.assumption,
  };
}

const TEST_TYPE_VARIANT = {
  Parametrik: "parametric",
  "Non-Parametrik": "nonParametric",
  Betimsel: "descriptive",
  Tahmini: "predictive",
};

export function getTestParametricMeta(testId) {
  const item = getCatalogTest(testId);
  const labelTr = item?.type || "Parametrik";
  return {
    label: labelTr,
    labelTr,
    variant: TEST_TYPE_VARIANT[labelTr] || "parametric",
  };
}

/**
 * Catalog-level locks (demo). Empty — aft/cox/multinomial/poisson/roc/log_rank
 * are gated only by profile-dataset `supported_tests`.
 */
export const LOCKED_TEST_IDS = new Set([]);

export const TEST_LOCK_MESSAGES = {};

export function isTestLocked(testId) {
  return LOCKED_TEST_IDS.has(testId);
}

export function getTestLockMessage(testId) {
  return TEST_LOCK_MESSAGES[testId] || null;
}

export function getTestClinicalEducation(testId) {
  const item = getCatalogTest(testId);
  if (!item) {
    return {
      tr: {
        purpose: "Klinik araştırma verinizde uygun istatistiksel çıkarım yapar.",
        scenario: "Değişkenleri seçip sihirbazı başlatarak analizi tamamlayın.",
      },
      en: {
        purpose: "Supports valid statistical inference on your clinical dataset.",
        scenario: "Select variables and launch the wizard to complete the analysis.",
      },
    };
  }
  return {
    tr: { purpose: item.descriptionTR, scenario: item.scenarioTR },
    en: { purpose: item.descriptionEN, scenario: item.scenarioEN },
  };
}

/** Resolve catalog description/scenario for the active app language (tr, en, fr). */
export function getCatalogLocalizedCopy(item, language = "en") {
  const lang = String(language || "en")
    .toLowerCase()
    .split(/[-_]/)[0];
  if (!item) {
    return { description: "", scenario: "" };
  }
  if (lang === "tr") {
    return {
      description: item.descriptionTR || item.descriptionEN || item.descriptionFR || "",
      scenario: item.scenarioTR || item.scenarioEN || item.scenarioFR || "",
    };
  }
  if (lang === "fr") {
    return {
      description: item.descriptionFR || item.descriptionEN || item.descriptionTR || "",
      scenario: item.scenarioFR || item.scenarioEN || item.scenarioTR || "",
    };
  }
  return {
    description: item.descriptionEN || item.descriptionTR || item.descriptionFR || "",
    scenario: item.scenarioEN || item.scenarioTR || item.scenarioFR || "",
  };
}

/** Purpose + scenario for the active language (used by legacy TestCard info panel). */
export function getLocalizedClinicalEducation(testId, language = "en") {
  const education = getTestClinicalEducation(testId);
  const lang = String(language || "en")
    .toLowerCase()
    .split(/[-_]/)[0];
  if (lang === "tr") return education.tr || education.en || education.fr;
  if (lang === "fr") return education.fr || education.en || education.tr;
  return education.en || education.tr || education.fr;
}

/** Resolve localized test name (tr, en, fr). */
export function getTestLocalizedName(item, language = "en") {
  if (!item) return "";
  const lang = String(language || "en").toLowerCase().split(/[-_]/)[0];
  if (lang === "tr") return item.nameTR || item.name || "";
  if (lang === "fr") return item.nameFR || item.nameEN || item.name || "";
  return item.nameEN || item.name || item.nameTR || "";
}

const SLOT_LABEL_TRANSLATIONS = {
  time_point_1: {
    tr: "Zaman Noktası 1 (Pre-op / t0)",
    en: "Time Point 1 (Pre-op / t0)",
    fr: "Point temporel 1 (Pré-op / t0)",
  },
  time_point_2: {
    tr: "Zaman Noktası 2 (Post-op / t1)",
    en: "Time Point 2 (Post-op / t1)",
    fr: "Point temporel 2 (Post-op / t1)",
  },
  time_point_2_interim: {
    tr: "Zaman Noktası 2 (Ara / t1)",
    en: "Time Point 2 (Interim / t1)",
    fr: "Point temporel 2 (Intermédiaire / t1)",
  },
  time_point_3: {
    tr: "Zaman Noktası 3 (Takip / t2)",
    en: "Time Point 3 (Follow-up / t2)",
    fr: "Point temporel 3 (Suivi / t2)",
  },
  time_point_4: {
    tr: "Zaman Noktası 4 (Opsiyonel / t3)",
    en: "Time Point 4 (Optional / t3)",
    fr: "Point temporel 4 (Optionnel / t3)",
  },
  time_point_1_binary: {
    tr: "Zaman Noktası 1 (İkili Kategorik)",
    en: "Time Point 1 (Binary Categorical)",
    fr: "Point temporel 1 (Binaire Catégoriel)",
  },
  time_point_2_binary: {
    tr: "Zaman Noktası 2 (İkili Kategorik)",
    en: "Time Point 2 (Binary Categorical)",
    fr: "Point temporel 2 (Binaire Catégoriel)",
  },
  item_1: {
    tr: "Madde / Item 1",
    en: "Item 1",
    fr: "Item 1",
  },
  item_2: {
    tr: "Madde / Item 2",
    en: "Item 2",
    fr: "Item 2",
  },
  item_3: {
    tr: "Madde / Item 3",
    en: "Item 3",
    fr: "Item 3",
  },
  item_4: {
    tr: "Madde / Item 4 (Opsiyonel)",
    en: "Item 4 (Optional)",
    fr: "Item 4 (Optionnel)",
  },
  rater_1: {
    tr: "Kodlayıcı / Gözlemci 1",
    en: "Rater / Observer 1",
    fr: "Évaluateur / Observateur 1",
  },
  rater_2: {
    tr: "Kodlayıcı / Gözlemci 2",
    en: "Rater / Observer 2",
    fr: "Évaluateur / Observateur 2",
  },
  variable: {
    tr: "Sonuç Değişkeni (Sürekli)",
    en: "Outcome Variable (Continuous)",
    fr: "Variable de résultat (Continue)",
  },
  group_by: {
    tr: "Grup Değişkeni (Kategorik)",
    en: "Grouping Variable (Categorical)",
    fr: "Variable de groupe (Catégorielle)",
  },
  group_by_2: {
    tr: "Grup Değişkeni (Kategorik — önerilen: 2 seviye)",
    en: "Grouping Variable (Categorical — recommended: 2 levels)",
    fr: "Variable de groupe (Catégorielle — recommandé : 2 niveaux)",
  },
  group_by_3: {
    tr: "Grup Değişkeni (Kategorik — önerilen: ≥3 seviye)",
    en: "Grouping Variable (Categorical — recommended: ≥3 levels)",
    fr: "Variable de groupe (Catégorielle — recommandé : ≥3 niveaux)",
  },
  group_by_optional: {
    tr: "Grup Değişkeni (Opsiyonel)",
    en: "Grouping Variable (Optional)",
    fr: "Variable de groupe (Optionnelle)",
  },
  target_y_continuous: {
    tr: "Hedef / Bağımlı Değişken (Y Ekseni - Sürekli)",
    en: "Target / Dependent Variable (Y Axis - Continuous)",
    fr: "Variable cible / dépendante (Axe Y - Continu)",
  },
  pred_x_continuous: {
    tr: "Bağımsız Öngörücü (X Ekseni - Sürekli)",
    en: "Independent Predictor (X Axis - Continuous)",
    fr: "Prédicteur indépendant (Axe X - Continu)",
  },
  pred_1_continuous: {
    tr: "1. Bağımsız Öngörücü (X Ekseni - Sürekli)",
    en: "1st Independent Predictor (X Axis - Continuous)",
    fr: "1er prédicteur indépendant (Axe X - Continu)",
  },
  pred_2_continuous: {
    tr: "2. Bağımsız Öngörücü (Z Ekseni - Sürekli)",
    en: "2nd Independent Predictor (Z Axis - Continuous)",
    fr: "2e prédicteur indépendant (Axe Z - Continu)",
  },
  variable_b: {
    tr: "1. Bağımsız Öngörücü (Sürekli)",
    en: "1st Independent Predictor (Continuous)",
    fr: "1er prédicteur indépendant (Continu)",
  },
  x_col_b: {
    tr: "2. Bağımsız Öngörücü (Sürekli)",
    en: "2nd Independent Predictor (Continuous)",
    fr: "2e prédicteur indépendant (Continu)",
  },
  count_y: {
    tr: "Sayım / Count Sonucu (Y)",
    en: "Count Outcome (Y)",
    fr: "Résultat de comptage (Y)",
  },
  pred_x: {
    tr: "Bağımsız Öngörücü (X)",
    en: "Independent Predictor (X)",
    fr: "Prédicteur indépendant (X)",
  },
  cat_var_1: {
    tr: "Kategorik Değişken 1 (önerilen: 2 seviye)",
    en: "Categorical Variable 1 (recommended: 2 levels)",
    fr: "Variable catégorielle 1 (recommandé : 2 niveaux)",
  },
  // Fisher R×C yuvası (her değişkende 2–5 kategori).
  fisher_cat_var_1: {
    tr: "Kategorik Değişken 1 (2–5 kategori)",
    en: "Categorical Variable 1 (2–5 categories)",
    fr: "Variable catégorielle 1 (2–5 catégories)",
  },
  cat_var_2: {
    tr: "Kategorik Değişken 2 (önerilen: 2 seviye)",
    en: "Categorical Variable 2 (recommended: 2 levels)",
    fr: "Variable catégorielle 2 (recommandé : 2 niveaux)",
  },
  // Fisher R×C yuvası (her değişkende 2–5 kategori).
  fisher_cat_var_2: {
    tr: "Kategorik Değişken 2 (2–5 kategori)",
    en: "Categorical Variable 2 (2–5 categories)",
    fr: "Variable catégorielle 2 (2–5 catégories)",
  },
  duration: {
    tr: "Süre / Takip Zamanı (Sürekli)",
    en: "Duration / Follow-up Time (Continuous)",
    fr: "Durée / Temps de suivi (Continu)",
  },
  event_column: {
    tr: "Olay / Durum Değişkeni (0/1)",
    en: "Event / Status Variable (0/1)",
    fr: "Événement / Statut (0/1)",
  },
  stratifier: {
    tr: "Tabaka / Karşılaştırma Grubu",
    en: "Stratifier / Comparison Group",
    fr: "Strate / Groupe de comparaison",
  },
  gold_standard: {
    tr: "Altın Standart / Gerçek Tanı (0/1)",
    en: "Gold Standard / True Diagnosis (0/1)",
    fr: "Standard de référence / Diagnostic vrai (0/1)",
  },
  test_variable: {
    tr: "Değerlendirilen Test / Skor",
    en: "Evaluated Test / Score",
    fr: "Test / Score évalué",
  },
  row_var: {
    tr: "Satır Değişkeni (Kategorik)",
    en: "Row Variable (Categorical)",
    fr: "Variable de ligne (Catégorielle)",
  },
  col_var: {
    tr: "Sütun Değişkeni (Kategorik)",
    en: "Column Variable (Categorical)",
    fr: "Variable de colonne (Catégorielle)",
  },
};

/** Resolve localized slot label for variable mapping. */
export function getSlotLocalizedLabel(slot, language = "en") {
  if (!slot) return "";
  const lang = String(language || "en").toLowerCase().split(/[-_]/)[0];
  if (lang === "tr" && slot.labelTR) return slot.labelTR;
  if (lang === "fr" && slot.labelFR) return slot.labelFR;
  if (lang === "en" && slot.labelEN) return slot.labelEN;

  const rawLabel = String(slot.label || "").trim();
  if (rawLabel) {
    for (const val of Object.values(SLOT_LABEL_TRANSLATIONS)) {
      if (val.tr === rawLabel || val.en === rawLabel || val.fr === rawLabel) {
        return val[lang] || val.en || rawLabel;
      }
    }

    // Backend/catalog labels may contain minor punctuation or suffix changes.
    // Resolve their semantic slot before falling back to raw Turkish copy.
    const normalized = rawLabel.replace(/\*/g, "").replace(/\s+/g, " ").trim();
    let aliasKey = null;
    if (/^sonuç değişkeni.*sürekli/i.test(normalized)) aliasKey = "variable";
    else if (/^grup değişkeni.*(?:≥\s*3|3 seviye)/i.test(normalized)) aliasKey = "group_by_3";
    else if (/^grup değişkeni.*(?:2 seviye)/i.test(normalized)) aliasKey = "group_by_2";
    else if (/^grup değişkeni.*opsiyonel/i.test(normalized)) aliasKey = "group_by_optional";
    else if (/^grup değişkeni/i.test(normalized)) aliasKey = "group_by";
    else if (/^kategorik değişken 1.*2–5/i.test(normalized)) aliasKey = "fisher_cat_var_1";
    else if (/^kategorik değişken 2.*2–5/i.test(normalized)) aliasKey = "fisher_cat_var_2";
    else if (/^kategorik değişken 1/i.test(normalized)) aliasKey = "cat_var_1";
    else if (/^kategorik değişken 2/i.test(normalized)) aliasKey = "cat_var_2";
    if (aliasKey) {
      return SLOT_LABEL_TRANSLATIONS[aliasKey]?.[lang] || SLOT_LABEL_TRANSLATIONS[aliasKey]?.en || rawLabel;
    }
    // Klinik modül yuvaları (tarama / fenotipleme) etiketlerini kendi kataloglarında taşır.
    for (const test of Array.isArray(_CLINICAL_CATALOG) ? _CLINICAL_CATALOG : []) {
      const hit = (test.slots || []).find((s) => s.label === normalized || s.labelTR === normalized);
      if (hit) {
        if (lang === "tr") return hit.labelTR || hit.label;
        if (lang === "fr") return hit.labelFR || hit.labelEN || hit.label;
        return hit.labelEN || hit.label;
      }
    }
    if (lang === "tr") return rawLabel;
  }

  const key = slot.key || slot.id;
  if (key && SLOT_LABEL_TRANSLATIONS[key]) {
    return SLOT_LABEL_TRANSLATIONS[key][lang] || SLOT_LABEL_TRANSLATIONS[key].en || slot.label;
  }

  return slot.label || "";
}

/** Resolve localized type badge (Parametric, Non-Parametric, Descriptive, etc.) */
export function getTestTypeLocalizedLabel(type, language = "en") {
  if (!type) return "";
  const lang = String(language || "en").toLowerCase().split(/[-_]/)[0];
  const tNorm = String(type).trim().toLowerCase();

  if (tNorm.includes("non-param") || tNorm.includes("non param")) {
    if (lang === "fr") return "Non paramétrique";
    if (lang === "en") return "Non-Parametric";
    return "Non-Parametrik";
  }
  if (tNorm.includes("param")) {
    if (lang === "fr") return "Paramétrique";
    if (lang === "en") return "Parametric";
    return "Parametrik";
  }
  if (tNorm.includes("betimsel") || tNorm.includes("descript")) {
    if (lang === "fr") return "Descriptif";
    if (lang === "en") return "Descriptive";
    return "Betimsel";
  }
  if (tNorm.includes("tahmin") || tNorm.includes("predict")) {
    if (lang === "fr") return "Prédictif";
    if (lang === "en") return "Predictive";
    return "Tahmini";
  }
  if (tNorm.includes("taran") || tNorm.includes("scan")) {
    if (lang === "fr") return "Analyse en cours";
    if (lang === "en") return "Scanning";
    return "Taranıyor";
  }
  return type;
}
